define('views/components/reseller_role/reseller_role',['require','backbone','text!templates/components/reseller_role/reseller_role.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/reseller_role/reseller_role.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'reseller-role-item'
    });
});
